const defaultPatientsSearch = {
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  patientNo: '',
};

export default defaultPatientsSearch;
